<template>
  <div class="bidlist">
    <div class="mb-4">
      <PopupLinkPartner v-if="canSendInvite" />

      <DateFilter @change="applyDateFilter" @change-date="setDateFilter" :value="dateFilter" />
    </div>

    <v-data-table
      class="bidlist-table"
      :headers="headers"
      :items="team"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="footerProps"
      item-key="id"
      @update:options="applySort"
    />
  </div>
</template>


<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DateFilter from "../common/DateFilter";
import PopupLinkPartner from "./PopupLinkPartner";

export default {
  components: {
    PopupLinkPartner,
    DateFilter,
  },
  data() {
    return {
      downloadItem: true,
      headers: [
        {
          text: "Партнёр",
          value: "name",
          sortable: false,
        },
        {
          text: "ИНН",
          value: "inn",
          sortable: false,
        },
        {
          text: "Открытые счета",
          value: "requests_count",
          sortable: true,
        },
        {
          text: "Дата регистрации",
          value: "registration_date",
          sortable: true,
        },
      ],
      footerProps: {
        itemsPerPageText: "Партнёров на странице:",
        itemsPerPageOptions: [5, 10, 15],
      },
    };
  },
  computed: {
    ...mapState("team", ["team", "page", "pageSize", "total"]),
    ...mapGetters("team", ["hasTeam", "dateFilter"]),
    ...mapGetters("profile", ["canSendInvite"]),
    options: {
      get() {
        return {
          page: this.page,
          itemsPerPage: this.pageSize,
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      },
    },
  },
  methods: {
    ...mapMutations("team", ["setDateFilter", "setSort", "setPage", "setPageSize"]),
    ...mapActions("team", ["getTeam"]),
    async applyDateFilter({ start, end }) {
      this.setDateFilter({ start, end });
      await this.getTeam();
    },
    async applySort(e) {
      this.setSort(e);
      await this.getTeam();
    },
  },
  watch: {
    options: {
      handler() {
        this.getTeam();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #777c87;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  font-weight: 400;
  height: auto;
  padding: 12px 16px;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px;
}

.v-data-table-header {
  background-color: #f5f5f6;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}
</style>
